import Skeleton from '@/components/ui/Skeleton'

/**
 * StockHeader before the company has loaded — the Stock route's pending page
 * draws it, so the header is there from the first frame instead of popping
 * in above a skeleton that had none.
 *
 * Its own module rather than a second export of StockHeader.tsx: a route's
 * `pendingComponent` is not code-split, so whatever it imports lands in the
 * entry chunk — and StockHeader brings the alert modal with it.
 *
 * The same boxes as the loaded header: a 40px logo beside the `h-2xl` ticker
 * and the one-line name, then the three 36px buttons at the right. The ticker
 * is the real one — it is the URL's — and everything the API has to supply is
 * a bar.
 */
export default function StockHeaderSkeleton({ symbol }: { symbol: string }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-4">
      <div className="flex min-w-0 items-center gap-3">
        <Skeleton className="size-10 shrink-0 rounded-full" />
        <div className="min-w-0">
          <h1 className="text-h-2xl">{symbol}</h1>
          <div className="flex h-5 items-center">
            <Skeleton className="h-3 w-52 rounded-xs" />
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <Skeleton className="h-9 w-28 rounded-sm" />
        <Skeleton className="h-9 w-20 rounded-sm" />
        <Skeleton className="h-9 w-28 rounded-sm" />
      </div>
    </div>
  )
}
